// =============================================================================
// clients-beneficiaries-client.ts — Client API des CLIENTS BÉNÉFICIAIRES diffusés (S33), DOUBLABLE.
// =============================================================================
// Miroir HTTP de la présentation CONDITIONNELLE des clients bénéficiaires d'une campagne
// (apps/api/src/client-reference/client-beneficiary-diffusion.service.ts). La diffusion des NOMS est
// gate-ée par le flag admin `campaign.clients_diffusion_enabled` (F0-DB-2, A0-6 OPTION 1, DBU §3.3
// l.2581/2588/2608/2648). Comme les autres clients UI, expose une INTERFACE consommée par l'écran ;
// l'impl HTTP réelle viendra derrière la MÊME interface (stub-first).
//
// >>> FLAG CARRIER / ENDPOINT (pour ORCH) <<<
// L'endpoint réel (ex. GET /admin/clients/campaigns/:campaignId/beneficiaries) et son carrier
// (source des SIREN bénéficiaires via campaign + lecture du flag) sont câblés HORS de ce lot (rescope
// lane CLIENT). Tant qu'ils ne sont pas branchés, le défaut fail-closed masque les noms.
//
// DTO = miroirs HTTP (PAS le Published Language). AUCUN nom n'est présent dans le DTO quand la
// diffusion n'est PAS autorisée (masquage côté serveur — le front ne peut pas « déduire » un nom).

import { HttpApiError } from '@/api/http-error';

/** Un client bénéficiaire DIFFUSÉ (nom visible). Présent uniquement si la diffusion est autorisée. */
export interface BeneficiaryDto {
  readonly siren: string;
  readonly raisonSociale: string;
}

/** Vue OUTPUT des clients bénéficiaires d'une campagne, diffusion gate-ée par le flag admin. */
export interface ClientBeneficiariesDiffusionDto {
  /** Reflet du flag `campaign.clients_diffusion_enabled` résolu pour cette campagne. */
  readonly diffusionEnabled: boolean;
  /** Nombre de clients bénéficiaires (cardinalité NON-nominative) — présent dans les deux états. */
  readonly beneficiaryCount: number;
  /** Noms diffusés. Vide (`[]`) quand `diffusionEnabled=false` (masqué). */
  readonly beneficiaries: readonly BeneficiaryDto[];
}

/** Erreur applicative renvoyée par l'API admin (HTTP 4xx). Affichée telle quelle. */
export class ClientBeneficiariesApiError extends HttpApiError {
  public constructor(message: string, status?: number) {
    super(message, status, 'ClientBeneficiariesApiError');
  }
}

/** Contrat du client des bénéficiaires diffusés (miroir d'un endpoint FLAGGÉ, carrier ORCH). */
export interface ClientBeneficiariesClient {
  /**
   * Présente les clients bénéficiaires d'une campagne, noms diffusés ou masqués selon le flag admin.
   * @param campaignId Campagne dont on lit le flag de diffusion (grain per-campagne).
   */
  listBeneficiaries(campaignId: string): Promise<ClientBeneficiariesDiffusionDto>;
}
